import * as tslib_1 from "tslib";
import { VuexModule, Module, Mutation, Action, getModule, } from "vuex-module-decorators";
import store from "@/store";
let Permission = class Permission extends VuexModule {
    constructor() {
        super(...arguments);
        // --------------------State--------------------
        this._routes = [];
    }
    // --------------------Getters--------------------
    get routes() {
        return this._routes;
    }
    // --------------------Mutation--------------------
    SET_ROUTES(routes) {
        this._routes = routes;
    }
    // --------------------Action--------------------
    setRoutes(routes) {
        return routes;
    }
};
tslib_1.__decorate([
    Mutation // 设置路由
], Permission.prototype, "SET_ROUTES", null);
tslib_1.__decorate([
    Action({ commit: "SET_ROUTES" }) // 设置路由
], Permission.prototype, "setRoutes", null);
Permission = tslib_1.__decorate([
    Module({ dynamic: true, store, name: "permission" })
], Permission);
export const PermissionModule = getModule(Permission);
